module.exports = __webpack_public_path__ + "assets/img/fe605f693115f836eec5aa85cbb6087b.svg";